import React from 'react';
import { motion } from 'framer-motion';
import energyImg from '../images/photos/energy.gif'; // replace with your actual image path

const pageVariants = {
  initial: { rotateY: 90, opacity: 0 },
  in: { rotateY: 0, opacity: 1 },
  out: { rotateY: -90, opacity: 0 }
};

const pageTransition = {
  type: 'spring',
  stiffness: 80,
  damping: 20
};

const Industries_EnergyUtilities = () => (
  <motion.div
    initial="initial"
    animate="in"
    exit="out"
    variants={pageVariants}
    transition={pageTransition}
    style={{
      minHeight: '60vh',
      padding: '20px',
      fontFamily:
        "Inter, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial",
      backgroundColor: '#f8fafc',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}
  >
    {/* Page Heading */}
    <h1
      style={{
        fontSize: '34px',
        marginBottom: '24px',
        textAlign: 'center',
        color: '#1e293b'
      }}
    >
      Energy & Utilities
    </h1>

    <section
      style={{
        maxWidth: '1200px',
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '20px'
      }}
    >
      {/* Left: Image */}
      <div style={{ flex: '1 1 300px', display: 'flex', justifyContent: 'center' }}>
        <img
          src={energyImg}
          alt="Energy and Utilities sector"
          style={{
            width: '100%',
            maxWidth: '500px',
            height: 'auto',
            borderRadius: '12px',
            boxShadow: '0 6px 20px rgba(0,0,0,0.08)'
          }}
        />
      </div>

      {/* Right: Content */}
      <div style={{ flex: '1 1 300px' }}>
        <p style={{ color: '#475569', lineHeight: 1.6 }}>
          Connecting Technology and Sustainability for Energy Innovation. Zyntro Software Solutions
          Pvt. Ltd. is at the forefront of transforming the energy and utilities sector with
          innovative, tech-driven solutions designed to optimize operations, improve efficiency, and
          drive sustainability. Our team of experts provides customized solutions ranging from energy
          management systems to real-time monitoring, predictive analytics, and digital
          transformation strategies.
        </p>
        <p style={{ color: '#475569', lineHeight: 1.6 }}>
          We specialize in streamlining energy production, distribution, and consumption to reduce
          costs, improve system reliability, and promote environmental sustainability. By integrating
          advanced technologies like IoT, cloud computing, and AI, we help businesses in the energy
          and utilities sector stay ahead of the curve and meet the growing demands of a dynamic
          market.
        </p>
        <p style={{ color: '#475569', lineHeight: 1.6 }}>
          Whether you’re looking to improve operational efficiency, enhance customer engagement, or
          transition to greener energy solutions, Zyntro Software Solutions Pvt. Ltd. is your trusted
          partner for sustainable and innovative tech solutions in energy and utilities.
        </p>
      </div>
    </section>
  </motion.div>
);

export default Industries_EnergyUtilities;
